module.exports = __webpack_public_path__ + "img/triangle_power.fd46617c.jpg";